/* eslint-disable */
import React, { Fragment, Dispatch, useState, useEffect } from "react";
import './wem.css';
import { useDispatch, useSelector } from "react-redux";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from '@material-ui/icons/Search';
import {
    Button,
    Card,
    CardContent,
    Dialog,
    DialogContent,
    makeStyles,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
} from "@material-ui/core";
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import InputLabel from "@material-ui/core/InputLabel";
import { getPartList, setPageNumber } from "../../store/actions/orderHistory.actions";
import AnnouncementIcon from "../../common/components/AnnouncementIcon";
import FullscreenLoader from "../../common/components/FullscreenLoader";
import NotificationIcon from "../../common/components/NotificationIcon";
import _, { get } from "lodash";
import { getWemList } from "../../store/actions/wem.actions";
import Carousel from "react-bootstrap/Carousel";
import IconButton from '@material-ui/core/IconButton';
import Select from '@material-ui/core/Select';
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import List from "@material-ui/icons/List";
import { Close } from "@material-ui/icons";
import VisibilityIcon from "@material-ui/icons/Visibility";
import RequestQuoteDialog from "./RequestQuoteDialog";
import { useHistory, useLocation } from "react-router-dom";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

const useStyles = makeStyles({
    blueTableHeader: {
        backgroundColor: "#0056b3",
        color: "#fff",
        padding: "8px",
        fontWeight: "bold",
        textAlign: "center",
    },
    blueTableBody: {
        backgroundColor: "#e6f0ff",
        color: "#000",
        padding: "8px",
        textAlign: "center",
    },
    highlightBox: {
        border: "2px solid orange",
        borderRadius: "12px",
    },
    tableContainer: {
        backgroundColor: "#fff",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        borderRadius: "8px",
        marginTop: "20px",
    },
    tableHeader: {
        backgroundColor: "#f8f9fa",
        fontWeight: 600,
        fontSize: "14px",
        color: "#333",
        padding: "16px 12px",
        borderBottom: "2px solid #dee2e6",
    },
    tableCell: {
        padding: "16px 12px",
        fontSize: "14px",
        color: "#495057",
        borderBottom: "1px solid #e9ecef",
    },
    customerName: {
        color: "#0d6efd",
        fontWeight: 500,
        textDecoration: "none",
        cursor: "pointer",
        "&:hover": {
            textDecoration: "underline",
        },
    },
    statusChip: {
        padding: "4px 12px",
        borderRadius: "4px",
        fontSize: "13px",
        fontWeight: 500,
        display: "inline-block",
    },
    viewButton: {
        color: "#0d6efd",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: "4px",
        fontSize: "14px",
        "&:hover": {
            textDecoration: "underline",
        },
    },
    backButton: {
        color: "#0d6efd",
        fontSize: "14px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        marginBottom: "20px",
        "&:hover": {
            textDecoration: "underline",
        },
    },
    noticeText: {
        color: "#ff9800",
        fontSize: "14px",
        marginTop: "20px",
        fontWeight: 500,
    },
    subText: {
        fontSize: "12px",
        color: "#6c757d",
        display: "block",
        marginTop: "2px",
    },
});

const ViewQuotationList: React.FC = () => {
    const classes = useStyles();
    const history = useHistory();

    // Hardcoded data - replace with API response
    // When you get API response, just do: setQuotationData(apiResponse.data)
    const [quotationData, setQuotationData] = useState([
        {
            quotationNo: "RQWEM00515",
            date: "29/04/2025",
            requestId: "WE00000001",
            customerName: "M/s Vivat International",
            customerCode: "45457875457",
            requestedBy: "Shabbash Khan",
            email: "Shabbash.Khan@gmail.com",
            contactNo: "+971 50809040",
            totalItems: 5,
            approvedItems: "-",
            status: "Offer Updated",
            action: "View Quotation",
        },
        {
            quotationNo: "RQWEM00515",
            date: "29/04/2025",
            requestId: "WE00000002",
            customerName: "M/s Vivat International",
            customerCode: "45457875457",
            requestedBy: "Shabbash Khan",
            email: "Shabbash.Khan@gmail.com",
            contactNo: "+971 50809040",
            totalItems: 15,
            approvedItems: "-",
            status: "Revised Quote Requested",
            action: "View Quotation",
        },
        {
            quotationNo: "RQWEM00515",
            date: "29/04/2025",
            requestId: "WE00000003",
            customerName: "M/s Vivat International",
            customerCode: "45457875457",
            requestedBy: "Shabbash Khan",
            email: "Shabbash.Khan@gmail.com",
            contactNo: "+971 50809040",
            totalItems: 6,
            approvedItems: "-",
            status: "Approved",
            action: "View",
        },
        {
            quotationNo: "RQWEM00515",
            date: "29/04/2025",
            requestId: "WE00000004",
            customerName: "M/s Vivat International",
            customerCode: "45457875457",
            requestedBy: "Shabbash Khan",
            email: "Shabbash.Khan@gmail.com",
            contactNo: "+971 50809040",
            totalItems: 5,
            approvedItems: "-",
            status: "Rejected",
            action: "View",
        },
        {
            quotationNo: "RQWEM00515",
            date: "29/04/2025",
            requestId: "WE00000005",
            customerName: "M/s Vivat International",
            customerCode: "45457875457",
            requestedBy: "Shabbash Khan",
            email: "Shabbash.Khan@gmail.com",
            contactNo: "+971 50809040",
            totalItems: 20,
            approvedItems: "-",
            status: "Expired",
            action: "View",
        },
        {
            quotationNo: "RQWEM00515",
            date: "29/04/2025",
            requestId: "WE00000005",
            customerName: "M/s Vivat International",
            customerCode: "45457875457",
            requestedBy: "Shabbash Khan",
            email: "Shabbash.Khan@gmail.com",
            contactNo: "+971 50809040",
            totalItems: 20,
            approvedItems: "-",
            status: "Offer Revised",
            action: "View",
        },
        {
            quotationNo: "RQWEM00515",
            date: "29/04/2025",
            requestId: "WE00000005",
            customerName: "M/s Vivat International",
            customerCode: "45457875457",
            requestedBy: "Shabbash Khan",
            email: "Shabbash.Khan@gmail.com",
            contactNo: "+971 50809040",
            totalItems: 20,
            approvedItems: "-",
            status: "Requested",
            action: "View",
        },
    ]);

    const [searchText, setSearchText] = useState("");
    const dispatch: Dispatch<any> = useDispatch();
    const { wemList }: any = useSelector((state: any) => state.wem);
    const { materialGroups }: any = useSelector((state: any) => state.materialGroups);
    let materialGroupsData = get(materialGroups, "data.data", null);
    const { isSellingPriceData, profileDetails }: any = useSelector(
        (state: any) => state.profileDetails
    );
    const customerTierType = get(
        profileDetails,
        "data.data.customerInfo.customerTierType",
        ""
    );

    // useEffect to fetch data from API when component mounts
    useEffect(() => {
        // Uncomment and use when API is ready
        // fetchQuotationList();
    }, []);

    // Function to fetch quotation list from API
    const fetchQuotationList = async () => {
        try {
            // Replace with your actual API call
            // const response = await getQuotationListAPI();
            // setQuotationData(response.data);
        } catch (error) {
            console.error("Error fetching quotation list:", error);
        }
    };

    // Function to handle view quotation
    const handleViewQuotation = (row: any) => {
        // Add your navigation or modal logic here
        // Example: history.push(`/quotation/${row.requestId}`);
    };

    // Function to get status color based on status
    const getStatusColor = (status: string) => {
        switch (status.toLowerCase()) {
            case "approved":
                return { backgroundColor: "#d4edda", color: "#155724" };
            case "rejected":
                return { backgroundColor: "#f8d7da", color: "#721c24" };
            case "expired":
                return { backgroundColor: "#fff3cd", color: "#856404" };
            case "offer updated":
                return { backgroundColor: "#d1ecf1", color: "#0c5460" };
            case "revised quote requested":
                return { backgroundColor: "#e2e3e5", color: "#383d41" };
            case "offer revised":
                return { backgroundColor: "#d1ecf1", color: "#0c5460" };
            case "requested":
                return { backgroundColor: "#cce5ff", color: "#004085" };
            default:
                return { backgroundColor: "#e9ecef", color: "#495057" };
        }
    };

    return (
        <Fragment>
            {wemList?.loading && <FullscreenLoader />}

            <div className="d-flex align-items-center">
                <h2 className="page-title">List of Quotation</h2>
                <div className="ml-auto d-flex align-items-center">
                    <AnnouncementIcon />
                    <NotificationIcon />
                </div>
            </div>

            <span className="cursor-pointer">
                <IconButton
                    onClick={() => {
                        history.push("/orderenquiry");
                    }}
                    className="mr-1 mt-2" size="small">
                    <ArrowBackIosIcon fontSize="inherit" />
                    <span className="font-size-13 load-from-fav-Quotation">
                        Back to List
                    </span>
                </IconButton>
            </span>

            <TableContainer component={Paper} className={classes.tableContainer}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.tableHeader}>
                                Quotation No.
                                <span className={classes.subText}>(Date)</span>
                            </TableCell>
                            <TableCell className={classes.tableHeader}>Request ID</TableCell>
                            <TableCell className={classes.tableHeader}>Customer Name</TableCell>
                            <TableCell className={classes.tableHeader}>
                                Requested By
                                <span className={classes.subText}>(Email ID)</span>
                            </TableCell>
                            <TableCell className={classes.tableHeader}>Contact No.</TableCell>
                            <TableCell className={classes.tableHeader}>Total Items</TableCell>
                            <TableCell className={classes.tableHeader}>Approved Items</TableCell>
                            <TableCell className={classes.tableHeader}>Status</TableCell>
                            <TableCell className={classes.tableHeader}>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {quotationData.map((row, index) => (
                            <TableRow key={index} hover>
                                <TableCell className={classes.tableCell}>
                                    <div>{row.quotationNo}</div>
                                    <span className={classes.subText}>{row.date}</span>
                                </TableCell>
                                <TableCell className={classes.tableCell}>{row.requestId}</TableCell>
                                <TableCell className={classes.tableCell}>
                                    <div className={classes.customerName}>{row.customerName}</div>
                                    <span className={classes.subText}>{row.customerCode}</span>
                                </TableCell>
                                <TableCell className={classes.tableCell}>
                                    <div>{row.requestedBy}</div>
                                    <span className={classes.subText}>{row.email}</span>
                                </TableCell>
                                <TableCell className={classes.tableCell}>{row.contactNo}</TableCell>
                                <TableCell className={classes.tableCell} align="center">
                                    {row.totalItems}
                                </TableCell>
                                <TableCell className={classes.tableCell} align="center">
                                    {row.approvedItems}
                                </TableCell>
                                <TableCell className={classes.tableCell}>
                                    <span
                                        className={classes.statusChip}
                                        style={getStatusColor(row.status)}
                                    >
                                        {row.status}
                                    </span>
                                </TableCell>
                                <TableCell className={classes.tableCell}>
                                    <div
                                        className={classes.viewButton}
                                        onClick={() => handleViewQuotation(row)}
                                    >
                                        <VisibilityIcon style={{ fontSize: "18px" }} />
                                        {row.action}
                                    </div>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <div className={classes.noticeText}>
                Quotation valid for 30 days from Quotation Request Date
            </div>
        </Fragment>
    );
};

export default ViewQuotationList;